import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default function setupPorts (ports, bodyScrollOptions = {}) {
  ports.opened.subscribe((id) => {
    const modalBody = document.querySelector('#' + id + ' [data-modal-content-body]')
    if (modalBody) {
      disableBodyScroll(modalBody, bodyScrollOptions)
    }

    const resetScroll = document.querySelector('#' + id + ' [data-modal-reset-scroll]')
    if (resetScroll) {
      resetScroll.scrollTop = 0
    }
  })

  ports.closed.subscribe((id) => {
    const modalBody = document.querySelector('#' + id + ' [data-modal-content-body]')
    if (modalBody) {
      enableBodyScroll(modalBody)
    }
  })
}
